import { Component } from '@angular/core';
import {Router} from '@angular/router';
import { HostListener } from '@angular/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'app';

  constructor(private router: Router) {}

  ngOnInit () { 
    if(JSON.parse(localStorage.getItem('objSesionUsuarioLogeado'))==null)
    {
      this.router.navigate(['./']);
    }
  }
  //Comentando porque cada f5 o refresh de la pagina se redirigue al login borrando toda la data los localstorage, info, etc.
  // @HostListener('window:beforeunload', ['$event'])
  // public beforeunloadHandler($event) {
  //   localStorage.clear();    
  // }
}
